export default function( $ ) {

  /* ---------------------------------------------------- *
   *  Navigation & Slider
   * ---------------------------------------------------- */
  (
    function() {

      $( '#mobile-nav-toggle' ).on( 'click', function( e ) {
        $( 'body' ).toggleClass( 'open-mobile-menu' );
      });

      $( '#mobile-nav-background' ).on( 'click', function( e ) {
        $( 'body' ).removeClass( 'open-mobile-menu' );
        e.preventDefault();
      } );
    }
  )();

  /* ---------------------------------------------------- *
   *  Navigation Large DropDown
   * ---------------------------------------------------- */

  (
    function() {
      let openmenu = 0;
      let navid = 0;
      let enterID;
      let leaveID;
      let speed = 500;

      const largeDropdown = $( '#header-large-dropdown' );
      const largeDropdownInner = $( '#header-large-dropdown-inner' );
      const mainNavigation = $( 'ul#menu-main-navigation' );

      $( '.dropdown-trigger a' ).click( function( event ) {
        const newnavid = $( this ).parent().attr( 'data-nav-id' );
        if ( !openmenu || newnavid !== navid ) {
          event.preventDefault();
        }
      } );

      $( '.dropdown-trigger' ).on( 'mouseenter touchstart', function( e ) {
        const $this = $( this );
        clearTimeout( leaveID );
        enterID = setTimeout( function() {

          if ( openmenu === 0 ) {
            largeDropdownInner.addClass( 'show' );
            openmenu = 1;
            navid = $this.attr( 'data-nav-id' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).show();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).addClass( 'active' );
          } else {
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
            navid = $this.attr( 'data-nav-id' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).show();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).addClass( 'active' );
          }
        }, speed );
      } ).on( 'mouseleave', function( e ) {
        clearTimeout( enterID );
        leaveID = setTimeout( function() {
          if ( openmenu === 1 ) {
            openmenu = 0;
            largeDropdownInner.removeClass( 'show' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
          }
        }, speed );
      } );

      largeDropdownInner.mouseenter( function() {
        clearTimeout( leaveID );
      } ).mouseleave( function() {
        leaveID = setTimeout( function() {
          if ( openmenu === 1 ) {
            openmenu = 0;
            largeDropdownInner.removeClass( 'show' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
          }
        }, speed );
      } );

      $( '#header-large-dropdown .btn-close' ).click( function( event ) {
        if ( openmenu === 1 ) {
          largeDropdownInner.removeClass( 'show' );
          largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
          mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
          openmenu = 0;
          navid = 0;
        }
      } );

      $( document ).on( 'touchstart', function( e ) {
        if ( openmenu === 1 ) {
          const offset = $( '#header-large-dropdown-inner, #main-nav' ).offset();
          const offsetBottom = offset.top + $( '#header-large-dropdown-inner' ).height();
          const yPos = e.originalEvent.touches[0].pageY;
          if ( yPos < offset.top || yPos > offsetBottom ) {
            largeDropdownInner.removeClass( 'show' );
            largeDropdown.find( '.main-nav-inner[data-nav-id=' + navid + ']' ).hide();
            mainNavigation.find( '.menu-item[data-nav-id=' + navid + ']' ).removeClass( 'active' );
            openmenu = 0;
            navid = 0;
          }
        }
      } );
    }
  )();

  /* ---------------------------------------------------- *
   *  Navigation Mobile
   * ---------------------------------------------------- */

  (
    function() {
      let mobid = 0;
      $( '#mobile-nav .menu-item-has-children > a' ).click( function() {
        const $this = $( this );
        const newMobid = $this.parent().attr( 'id' ).replace( /^\D+/g, '' );
        if ( mobid === 0 ) {
          $this.parent().addClass( 'show' );
          mobid = newMobid;
        } else {
          if ( mobid === newMobid ) {
            $this.parent().removeClass( 'show' );
            mobid = 0;
          } else {
            $( '#mobile-nav .menu-item-has-children' ).removeClass( 'show' );
            $this.parent().addClass( 'show' );
            mobid = newMobid;
          }
        }
        return false;
      } );
    }
  )();
}
